module.exports = __webpack_public_path__ + "static/media/400003_02.036afeda.png";